/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.0.0
 */
import isNumber from 'lodash/isNumber';

import { IOptionItemProps } from '../components/common/Select/Select';
import { SortEnum } from '../components/Table/components/Filters/Filter';
import { TABLE_NO_VALUE_OPTION } from '../components/Table/sagas/loadTableMetaSagas';

export interface IFilters {
    filter?: any;
    sort?: {
        direction?: string;
        property?: string;
    };
    f?: any;
    s?: {
        direction?: string;
        property?: string;
    };
}

/**
 *  A way to base64 encode unicode string.
 *  Got from https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa
 * @param str str to base64 encode
 */
export const utoa = (str: string) => {
    return window.btoa(unescape(encodeURIComponent(str)));
};

export const filterToJson = (filters: IFilters) => {
    const obj: IFilters = {
        s: {},
        f: {},
    };
    if (filters.sort && filters.sort.direction !== SortEnum.default && obj.s) {
        obj.s.property = filters.sort.property;
        obj.s.direction = filters.sort.direction;
    }
    const filter = filters.filter;

    for (const property in filter) {
        if (filter[property]) {
            if (Array.isArray(filter[property])) { // if it is array of options
                obj.f[property] = {};
                if (property === 'labels') {
                    obj.f[property].include = filter[property]
                        .map((data: IOptionItemProps) => +data.value);
                } else {
                    obj.f[property].value = filter[property]
                        .map((data: IOptionItemProps) =>
                            utoa(data.value === TABLE_NO_VALUE_OPTION ? data.value : data.label));
                }
            } else if (filter[property].label) { // if it is single option
                obj.f[property] = {};
                if (property === 'assistantCampaignsCount'
                    || property === 'coordinatorCampaignsCount') {
                    const value = filter[property].value === 'exist' ? 1 : 0;
                    obj.f[property].value = value;
                } else {
                    obj.f[property].value = isNumber(filter[property].value)
                        ? filter[property].value
                        : utoa(filter[property].value);
                }
            } else if (filter[property].startDate) {
                obj.f[property] = {};
                obj.f[property].valueFrom = filter[property].startDate;
                obj.f[property].valueTo = filter[property].endDate;
            } else if (
                filter[property].valueFrom || filter[property].valueTo
            ) {
                obj.f[property] = {};
                if (filter[property].valueFrom) {
                    obj.f[property].valueFrom = filter[property].valueFrom;
                }
                if (filter[property].valueTo) {
                    obj.f[property].valueTo = filter[property].valueTo;
                }
            } else if (typeof filter[property] === 'string') {
                obj.f[property] = {};
                obj.f[property].value = filter[property];
            }
        }
    }

    return obj;
};
